import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { FieldArray } from 'react-final-form-arrays';
import _ from 'lodash';
import currencyConversion from '../../utils/currencyConversion';
import './TopTwenty.less';

import TopTwentyCreditorForm from './TopTwentyCreditorForm';

class TopTwentyForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    schedule: PropTypes.any.isRequired,
    isDraft: PropTypes.bool,
  };

  static defaultProps = {
    onSubmit: () => null,
  };

  render() {
    const { onSubmit, schedule } = this.props;

    const confirm_remove_claim = () => confirm('Remove this creditor?');
    const confirm_move_claim = () => confirm('Move / renumber this claim?');
    const initialValue = { creditors: _.cloneDeep(_.get(schedule, 'data.creditors', [])) };
    initialValue.creditors.map((creditor) => {
      creditor.total = currencyConversion.toDollarsOrStr(creditor.total);
      creditor.deduction = currencyConversion.toDollarsOrStr(creditor.deduction);
      creditor.unsecured = currencyConversion.toDollarsOrStr(creditor.unsecured);
      return creditor;
    });
    return (
      <Form
        initialValues={initialValue}
        onSubmit={onSubmit}
        mutators={{
          ...arrayMutators,
        }}
        render={({ handleSubmit, pristine, form, submitting, values }) => (
          <form onSubmit={handleSubmit} id="parser-schedule-top20-form">
            <fieldset className="ir-search-double">
              <table id="creditors">
                <thead>
                  <tr>
                    <th colSpan={2} rowSpan="2" style={{ width: 125 }}>
                      <span className="label">Creditor name and address</span>
                    </th>
                    <th rowSpan="2" style={{ width: 125 }}>
                      <span className="label">Creditor contact information</span>
                    </th>
                    <th rowSpan="2" style={{ width: 115 }}>
                      <span className="label">Nature of the claim</span>
                    </th>
                    <th rowSpan="2" style={{ width: 100 }}>
                      <span className="label">Indicate if claim is contingent, unliquidated, or disputed</span>
                    </th>
                  </tr>
                  <tr></tr>
                </thead>
                <tbody>
                  <FieldArray name="creditors">
                    {({ fields }) =>
                      fields.map((name, index) => (
                        <Fragment>
                          <tr key={`${index}-top20`}>
                            <td rowSpan={3}>
                              <h2>{index + 1}.</h2>
                              <br />

                              {index > 0 && (
                                <React.Fragment>
                                  <div
                                    className="btn btn-primary btn-sm"
                                    onClick={() => confirm_move_claim() && fields.swap(index, index - 1)}
                                    title={`Swap this claim with ${index}`}
                                    style={{ width: '1em' }}
                                  >
                                    ▲
                                  </div>
                                  <br />
                                </React.Fragment>
                              )}

                              {index < fields.length - 1 && (
                                <React.Fragment>
                                  <div
                                    className="btn btn-primary btn-sm"
                                    onClick={() => confirm_move_claim() && fields.swap(index, index + 1)}
                                    title={`Swap this claim with ${index + 2}`}
                                    style={{ width: '1em' }}
                                  >
                                    ▼
                                  </div>
                                  <br />
                                </React.Fragment>
                              )}

                              <div
                                className="btn btn-danger btn-sm"
                                onClick={() => confirm_remove_claim() && fields.remove(index)}
                                title="Remove claim"
                                style={{ width: '1em' }}
                              >
                                X
                              </div>
                            </td>
                          </tr>

                          {TopTwentyCreditorForm(name, index, values)}
                        </Fragment>
                      ))
                    }
                  </FieldArray>
                </tbody>
              </table>
              <div className="editable">
                <button type="button" onClick={() => form.mutators.push('creditors', {})}>
                  Add creditor
                </button>
              </div>
              <div className="buttons">
                <button
                  type="submit"
                  disabled={submitting || (pristine && !this.props.isDraft)}
                  className="btn btn-primary"
                >
                  Submit Changes
                </button>

                <button
                  type="button"
                  onClick={() => {
                    if (
                      pristine ||
                      confirm(
                        'You are about to lose unsaved changes!\nPress "Cancel" to continue editing, "OK" to discard changes!'
                      )
                    )
                      this.props.onCancel();
                  }}
                  disabled={submitting}
                  className={`btn btn-link ${pristine ? '' : 'cancel-link'}`}
                >
                  {pristine ? 'Cancel Editing' : 'Discard Changes'}
                </button>
              </div>
            </fieldset>
          </form>
        )}
      />
    );
  }
}

export default TopTwentyForm;



// WEBPACK FOOTER //
// ./src/scheduleform/schedule_top20/TopTwentyForm.jsx